import { Box, FormControl, Grid, IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { getClient } from "../Providers/graphqlClient";
import cssVars from "../styles/vars.module.scss"
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react";
import { GET_CAT_CHILDREN } from "../graphql/categories/queries";
import useTranslation from "../hooks/useTranslation";
import { GET_STORE_CONFIG } from "../graphql/store/queries";
import CustomMetas from "../components/custom-metas/customMetas";
import BrandCard from "../components/brand-card";

const BrandsPage = (props) => {

    const brands = props.brandsData.categories.items?.at(0)?.children || []
    const parent = props.brandsData.categories.items?.at(0)
    const [brandsData, setBrandsData] = useState(brands)

    const filter = (value) => {
        setBrandsData(brands.filter(brand => !value || brand.name.toUpperCase().includes(value.toUpperCase())))
    }

    const { t } = useTranslation()
    const PlaceHolder = process.env.NEXT_PUBLIC_BASE_URL + "/media/wysiwyg/front-end/Bugnard-logo.svg"

    return (
        <Box className="container">
            <CustomMetas title={parent.meta_title || parent.name}
                description={parent.meta_description}
                keywords={parent.meta_keywords}
                page_type="product.item"
                image={parent.image}
                url={process.env.NEXT_PUBLIC_STORE_FRONT + `/brands.html`} />

            <Box sx={{ mt: 1, mb: 4 }}>
                <FormControl id="mainSearch" variant="standard">
                    <OutlinedInput
                        type="search"
                        sx={{ borderRadius: cssVars.radius, minWidth: { xs: "100%", md: "526px" } }}
                        placeholder={t("Search")}
                        size="small"
                        onChange={(e) => { filter(e.target.value) }}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton edge="end">
                                    <SearchIcon sx={theme => ({ fill: theme.palette.primary.main })} />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Box>
            <Grid container columns={5} columnSpacing={3} rowGap={4} component="section">
                {brandsData?.map((item) =>
                    <Grid item xs={5} md={1} key={item.uid} >
                        <BrandCard cat={item} productImgUrl={item.image || PlaceHolder}/>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}

export default BrandsPage;

export const getStaticProps = async ({ locale }) => {

    const client = getClient(locale)

    const { data: storeConfigData } = await client.query({
        query: GET_STORE_CONFIG,
    })

    const { data: brandsData } = await client.query({
        query: GET_CAT_CHILDREN,
        variables: {
            currentPage: 1,
            pageSize: 300,
            ids: storeConfigData.storeConfig.brand_category_id
        }
    })

    return {
        props: {
            brandsData,
        },
        revalidate: 10,
    }
}

